export class DietData {
  public static DAILY_ACTIVITY_DATA = [
    'Extremely Inactive (Not Well, Bed Rest, Fatigue)',
    'Sedentary (Long Sitting Job with No Exercise)',
    'Moderately Active (Your Job Involves you to be active mostly  Or Long Sitting Job but you Regularly Exercise / Walk /  Swims)',
    'Vigorously Active (Your Job involves more Physical Work (Like Naturalist, Fire fighter, Lifeguard, Military / Police personnel, Gym trainer,  Dance teacher,  Construction worker, Tour guide etc) or you walk/run/jogs a lot or do extensive workout regularly)',
  ];

  public static MARITAL_DATA = [
    'Married',
    'Unmarried',
    'Widowed',
    'Divorced',
    "Didn't want to mention",
  ];

  public static MEDICAL_CONDITION = [
    'PCOS',
    'Hirsutism (Excessive Hair growth on Face, Chest, or elsewhere)',
    'Irregular Periods or No Periods at all',
    'Weight Gain (Even you are not consuming enough calories)',
    'Acne / Skin Disorders / Dark Patches',
    'Fatigue (Excessive Weakness / Feeling of constant tiredness)',
    'Hair Fall / Male Pattern Baldness /  Hair Thinning',
    'Diabetes / Insulin Resistance',
    'Constipation (Often)',
    'Infertility / Facing Difficulty getting pregnant',
    'Depression / Anxiety',
    'Insomnia',
    'Blood Pressure',
    'Heart (Cardiac Issues)',
    'Dehydration',
    'Headaches (Often)',
    'High Cholesterol',
    'Iron Deficiency (Anemia)',
    'Indigestion (Often)',
    'Miscarriage',
    'Pregnancy - Gestational diabetes',
    'Pregnancy - High BP',
    'Menopause',
    'Kidney Stone',
    'Malnutrition',
    'Vertigo',
    'Eating Disorder',
    'Other',
  ];

  public static DIET_HABITS = [
    'Junk Food (Chips / Chocolates / Candies etc)',
    'Regularly Eats Out ( Fast Food / Restaurants / Burgers / Cafe etc)',
    'Eats out (Only Weekends)',
    'Eats out but very rarely - Prefer Homemade Food',
    'Homemade Food Only (Never Eats Out)',
    'Liquor - Daily',
    'Liquor - Only Weekends',
    'Liquor - Occasional',
    'Soft Drinks / Beverages - Regularly',
    'Soft Drinks / Beverages - Occasional',
    'Milk - Once Or Twice Daily',
    'Milk - Sometimes (Not Regular)',
    'Milk - Never',
    'Tea - More than 3 times Daily',
    'Tea - Twice Daily',
    'Tea - Once Daily',
    'Tea - Never / Occasional (Not Regular)',
    'Tea - Green Tea / Cardamom / Jasmine Tea - Regularly',
    'Tea - Green Tea / Cardamom / Jasmine Tea - Occasionally',
    "Daily Water Intake - Don't Know",
    'Daily Water Intake - 3-4 ltrs',
    'Daily Water Intake - 2-3 ltrs',
    'Daily Water Intake - 1-2 ltrs',
    'Daily Water Intake - Less than a litre',
    'Smoking - Never',
    'Smoking - Occasionally',
    'Smoking - Regularly',
    'Other',
  ];

  public static MEALS_PREFER = [
    'Vegetarian',
    'Vegetarian (Jain)',
    'Vegetarian + Eggs Only (No Meat)',
    'Non Vegetarian',
    'Other',
  ];

  public static CUISINES_PREFER = [
    'American',
    'Australian',
    'Chinese',
    'Italian',
    'Arabic',
    'French',
    'South Asian',
    'African',
    'European',
    'Maxican',
    'Canadian',
    'Carribean',
    'Afghani',
    'Bangladeshi',
    'Nepalese',
    'Pakistani',
    'Malaysian',
    'Indian - South India',
    'Indian - Punjabi',
    'Indian - Gujrati',
    'Indian - Maharashtrian',
    'Indian - Rajasthani',
    'Indian - North Indian( Awadhi/Mughae/Kashmiri )',
    'Indian - Bihari/Bhojpuri',
    'Indian - North East',
    'Indian - East India ( Bengali, Jharkhandi, Oriya )',
    'Indian - Sindhi',
    'Indian - Jain',
    'Other',
  ];

  public static WORKOUT_ROUTINE = [
    'None',
    'Cardio (Regularly)',
    'Cardio (Irregularly',
    'Aerobic (Daily)',
    'Aerobic (Weekly)',
    'Workout at Gym (Regularly)',
    'Workout at Gym (Irregularly)',
    'Workout at Home (Regularly)',
    'Workout at Home (Irregularly)',
    'Walking (Regularly)',
    'Walking (Irregularly)',
    'Swimming (Regularly)',
    'Swimming (Irregularly)',
    'Yoga (Daily)',
    'Yoga (Sometimes)',
    'Meditation (Daily)',
    'Meditation (Sometimes)',
    'Other',
  ];

  public static PARTICULAR_DIET = [
    'None',
    'High Protien Diet',
    'Keto Diet',
    'Vegan Diet',
    'Low-Carb Diet',
    'Intermittent Fasting Diet',
    'Low Fat Diet',
    'Other',
  ];

  public static COMMUNICATION_MODE = [
    'Search Engine (Google, Bing, Yahoo)',
    'Recommended by Friend or Colleague',
    'Instagram',
    'Other Social Media (Facebook, Twitter, Linkedin)',
    'Media, Blogs or Publications',
    'Other',
  ];
}
